export default __webpack_public_path__ + "static/media/imgActivity8-1.1611cbdf.png";